module.exports = __webpack_public_path__ + "img/folios-icon-active.6725777c.svg";